// extracted by mini-css-extract-plugin
export var attachment = "_qh-a";
export var emailContainer = "_qh-4";
export var emailContentPaddedContainer = "_qh-b";
export var emailHeader = "_qh-6";
export var emailIframe = "_qh-3";
export var emailInfoIcon = "_qh-9";
export var emailShortenedSummary = "_qh-e";
export var infoDropdown = "_qh-0";
export var infoRowBoundedContent = "_qh-d";
export var internal = "_qh-5";
export var merchant = "_qh-8";
export var messageInputContainer = "_qh-h";
export var normal = "_qh-7";
export var replyCard = "_qh-f";
export var subtleButton = "_qh-1";
export var subtleButtonIconContainer = "_qh-2";
export var toggleViewRepliesButton = "_qh-c";
export var wrappingText = "_qh-g";